import React from 'react';

import ChiefSliderComponent from '../../snippets/ChiefSliderComponent';
import Schedule from '../../snippets/Schedule';
import Books from './books';
import Cafe from './cafe';
import Slider from './slider';

// import History from '../HistoryPage/history'
// import WarMigrantsV2 from './chiefSlider/items/warMigrantsV2'

class HomePage extends React.Component {
  render() {
    return (
      <div className='mp'>
        <ChiefSliderComponent />
        <Slider films={this.props.films} openTrailer={this.props.openTrailer} />
        <Schedule
          heading='Сеанси'
          showDates={true}
          films={this.props.films}
          dates={this.props.dates}
          halls={this.props.halls}
          formats={this.props.formats}
          hallsById={this.props.hallsById}
          formatsById={this.props.formatsById}
          showHallFilter={false}
          showFormatFilter={false}
          handleSessionClick={this.props.handleSessionClick}
        />
        <Cafe />
        <Books />
        {/* <History /> */}
      </div>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePageWrapper.jsx